<script setup lang="ts">
import type { DSStory } from '@/types'

const props = defineProps({
  storyId: {
    type: String,
    required: true,
  },
  story: {
    type: Object as PropType<DSStory>,
    required: true,
  },
  modelValue: {
    type: Boolean,
    required: true,
  },
})

const $emit = defineEmits(['toggleEdit', 'update:modelValue'])

const story = toRef(props, 'story')

const { userId } = storeToRefs(useUserStore())

const isEditable = computed(() => {
  return story.value?.authorId === userId.value
})

const isCommentBlockOpen = computed({
  get: () => props.modelValue,
  set: (value: boolean) => $emit('update:modelValue', value),
})

function share() {
  if (navigator.share) {
    navigator.share({
      title: `${story.value?.topicTitle} | 親愛的陌生人`,
      text: `${story.value?.topicTitle}\nhttps://dearstranger.life/stories/${story.value?.id}?openExternalBrowser=1`,
      url: `/stories/${story.value?.id}?openExternalBrowser=1`,
    })
  }
}
</script>

<template>
  <div
    class="action-bar flex my-4 py-1 border-t border-b border-neutral-300 justify-evenly"
    size="medium"
  >
    <!-- Like -->
    <like-story-button
      :story-id="storyId"
      :author-id="story.authorId"
      :like-count="story.likeCount"
    />
    <!-- Comment -->
    <ui-button
      class="flex flex-row items-center justify-center flex-1"
      variant="ghost"
      @click="isCommentBlockOpen = !isCommentBlockOpen"
    >
      <i
        v-if="isCommentBlockOpen"
        i-ph-chat-text-fill
        class="text-[22px] !text-neutral-600"
      />
      <i
        v-else
        i-ph-chat-text
        class="text-[22px] !text-neutral-600"
      />

      <span v-show="story.replyCount && story.replyCount > 0" class="ml-1 text-neutral-600">{{
        story.replyCount
      }}</span>
    </ui-button>
    <!-- Share -->
    <ui-button
      class="flex flex-row items-center justify-center flex-1"
      variant="ghost"
      @click.prevent="share"
    >
      <i i-ph-export class="text-[22px] !text-neutral-600" />
    </ui-button>
    <!-- Edit -->
    <client-only>
      <ui-button
        v-if="isEditable"
        class="flex flex-row items-center justify-center flex-1"
        variant="ghost"
        @click="$emit('toggleEdit')"
      >
        <i i-ph-dots-three-vertical-bold class="text-[22px] !text-neutral-600" />
      </ui-button>
    </client-only>
  </div>
</template>

<style>
.action-bar > button {
  position: relative;
}
.action-bar > button:not(:last-child):after {
  position: absolute;
  content: '';
  top: 4px;
  right: 0;
  bottom: auto;
  left: auto;
  width: 0;
  height: 80%;
  border-left: 0.5px solid;
  @apply border-neutral-300;
}
</style>
